import type { SVGProps } from "react";

const stroke = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export const InstagramIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...stroke} {...props}>
    <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.2" cy="6.8" r="0.6" fill="currentColor" />
  </svg>
);

export const TikTokIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...stroke} {...props}>
    <path d="M14 3.5v11.2a3.8 3.8 0 1 1-3.8-3.8" />
    <path d="M14 3.5c.4 2.8 2.3 4.6 5.2 4.8" />
  </svg>
);

export const LinkedInIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...stroke} {...props}>
    <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
    <path d="M8 10.5v6M8 7.6v.1M11.5 16.5v-6M11.5 13.2c0-1.6 1-2.7 2.4-2.7s2.1 1 2.1 2.6v3.4" />
  </svg>
);

/** Official PieFolio social profiles (names are brand names, not translated). */
export const SOCIAL_LINKS = [
  { name: "Instagram", href: "https://www.instagram.com/piefolioai", Icon: InstagramIcon },
  { name: "TikTok", href: "https://www.tiktok.com/@piefolioai", Icon: TikTokIcon },
  { name: "LinkedIn", href: "https://www.linkedin.com/company/piefolioai/", Icon: LinkedInIcon },
] as const;
